import { CSSProperties } from 'react';

import { Badge, withStyles } from '@material-ui/core';
import { STooltip } from '@setvi/shared/components';

import { COMPANIES } from 'Enums/Companies';
import { useAppContext } from 'Providers/AppProvider/AppContext';

interface Props {
  style?: CSSProperties;
  type?: 'private-label' | 'strategic-vendor';
}

const StyledBadge = withStyles(() => ({
  badge: {
    position: 'relative',
    transform: 'none',
    color: '#ffffff',
    backgroundColor: (props: any) => props.bgcolor || '#572BD3'
  }
}))(Badge);

export const ProductLabel = ({ style, type = 'private-label' }: Props) => {
  const { user } = useAppContext();
  const isPrivateLabel = type === 'private-label';

  if (
    ![COMPANIES.SYSCO_DEV, COMPANIES.SYSCO_PROD].includes(user.CompanyID) &&
    type === 'strategic-vendor'
  )
    return null;

  return (
    <STooltip
      title={isPrivateLabel ? 'Private Label' : 'Strategic Vendor'}
      style={style}>
      <StyledBadge
        badgeContent={isPrivateLabel ? 'P' : 'S'}
        bgcolor={isPrivateLabel ? '#572BD3' : '#EF1B81'}
      />
    </STooltip>
  );
};
